import { IResponse } from '../../common/model/Core.model'
import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'
import { IContactCheckRequestDto, IContactCreateRequestDto, IContactDto, IContactSearchRequestDto, IContactUpdateRequestDto } from './Contact.model'

export const contactApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      contactSearch: builder.mutation<IResponse, IContactSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contact}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      contactLoadMore: builder.mutation<IResponse, IContactSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contact}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      contactCreate: builder.mutation<IContactDto, IContactCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contact}`,
            method: 'POST',
            body,
          }
        },
      }),
      contactGetById: builder.mutation<IContactDto, {id: string; fields?: string}>({
        query(parameters) {
          const queryParams = parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.contact}/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
      contactUpdateById: builder.mutation<IContactDto, IContactUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contact}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      contactDeleteById: builder.mutation<IContactDto, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.contact}/${id}`,
            method: 'DELETE',
          }
        },
      }),
      contactCheck: builder.mutation<void, IContactCheckRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.contact}/check`,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const {
  useContactSearchMutation,
  useContactLoadMoreMutation,
  useContactCreateMutation,
  useContactGetByIdMutation,
  useContactUpdateByIdMutation,
  useContactDeleteByIdMutation,
  useContactCheckMutation
} = contactApi
